/**
 * RS workspace name → Lookout slug candidate. Matches the slug regex the backend
 * enforces (lowercase alphanumerics + single hyphens, no leading/trailing hyphen,
 * 2–30 chars). NO uniqueness handling — the caller resolves collisions by
 * incrementing a numeric suffix via the existing checkSlug RPC.
 */
export function slugifyWorkspaceName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // non-alnum runs → single hyphen
    .replace(/^-+|-+$/g, '') // trim leading/trailing hyphens
    .slice(0, 30)
    .replace(/-+$/, ''); // re-trim in case the slice landed on a hyphen
}
